__turbopack_context__.v({
  "folderHeaderSharing": "FolderHeaderSharing-module__43m2Ya__folderHeaderSharing",
});
